import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import Content, { HTMLContent } from '../components/Content'

const FooterPageTemplate = ({ content, contentComponent }) => {
  const PageContent = contentComponent || Content
  return <PageContent content={content} />
}

export { FooterPageTemplate }

const FooterPage = ({ html, frontmatter }) => {
  return <FooterPageTemplate {...frontmatter} content={html} contentComponent={HTMLContent} />
}

export default FooterPage



// WEBPACK FOOTER //
// ./src/templates/footer-page.js